var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWheelchair(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "-2.4 -2.4 28.80 28.80",
    id: "wheelchair-left",
    "data-name": "Flat Color",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0,
    transform: "translate(0,0), scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-2.4, -2.4), scale(0.8999999999999999)",
    d: "M16,30.31956856821974C18.455674082400968,30.37127344355967,20.660433746212615,28.982164335448974,22.748322976753116,27.688438261620846C24.787774435795882,26.42472585280335,26.90406707299137,25.059748220538737,27.96304340362776,22.906866329411667C28.999935225686652,20.798881889922978,28.552257418342226,18.348567448144653,28.497723123679556,16C28.4443676235142,13.702198375481897,28.622883046675415,11.356611703741457,27.646528511509374,9.275873628755413C26.629933915473018,7.109378767912499,25.05342088533738,5.090917586772048,22.89438882345955,4.058568270633055C20.782405754402795,3.048715607703377,18.323794543803174,3.990333155797653,16,3.70704213405649C13.283174672936424,3.375837198211999,10.35510051385438,0.7567417521758815,8.06162037327886,2.2503231567493174C5.721089214994748,3.774545561378753,7.118936185318065,7.666524039652739,5.994170142135552,10.22313143809636C5.036060308434002,12.400927171004607,2.55305912458259,13.68297856282906,2.0125220144788436,15.999999999999998C1.4250982414661173,18.518001908348317,1.471962552116555,21.406181036642952,2.8792555558786574,23.57526533678173C4.277459100334065,25.730339900905197,7.129022951642993,26.233271182821525,9.413775311782949,27.407675790056402C11.585660448959842,28.524064575110224,13.558531913810457,30.268162803933862,16,30.31956856821974",
    fill: "#7ed0ec",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#ffffff",
    strokeWidth: 1.344
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M3,17H6V13a2,2,0,0,1,2-2h8V9H7A1,1,0,0,1,7,7h9V5a2,2,0,0,1,2-2h2a1,1,0,0,1,0,2H18v7a1,1,0,0,1-1,1H8v2h5a1,1,0,0,1,0,2H8a2,2,0,0,1-2,2H3a1,1,0,0,1,0-2Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "secondary",
    cx: 17,
    cy: 16,
    r: 5,
    style: {
      fill: "#2ca9bc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "primary-2",
    "data-name": "primary",
    cx: 17,
    cy: 16,
    r: 1.5,
    style: {
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M3,17H6V13a2,2,0,0,1,2-2h8V9H7A1,1,0,0,1,7,7h9V5a2,2,0,0,1,2-2h2a1,1,0,0,1,0,2H18v7a1,1,0,0,1-1,1H8v2h5a1,1,0,0,1,0,2H8a2,2,0,0,1-2,2H3a1,1,0,0,1,0-2Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "secondary",
    cx: 17,
    cy: 16,
    r: 5,
    style: {
      fill: "#2ca9bc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "primary-2",
    "data-name": "primary",
    cx: 17,
    cy: 16,
    r: 1.5,
    style: {
      fill: "#000000"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchair);
export default __webpack_public_path__ + "static/media/wheelchair.bb90ab0af9b282eb5b5497b57fe2ca19.svg";
export { ForwardRef as ReactComponent };